import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_right",
  "use": "icon-icon_arrow_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon_arrow_right\"><defs><style type=\"text/css\"></style></defs><path d=\"M317 133.7c-11.8 11.2-11.8 29.3 0 40.4l361.6 343-361.6 343c-11.8 11.2-11.8 29.3 0 40.5s30.9 11.2 42.6 0l376.6-357.3s16-14.8 16-26.1c0-10.4-16-26.1-16-26.1L359.6 133.7c-11.7-11.1-30.8-11.1-42.6 0z\" fill=\"#C8C8CD\" p-id=\"10203\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol